import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = process.env.REACT_APP_ROOT_URL;

export const baseQuery = fetchBaseQuery({
  baseUrl: `${BASE_URL}`,
  prepareHeaders: (headers, { getState }) => {
    const jwtToken = getState().authReducer.jwt;
    if (jwtToken) {
      headers.set('authorization', `Bearer ${jwtToken}`);
    }
    return headers;
  },
  credentials: 'include',
});
